import React, { useEffect, useState, Fragment } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Check, ShieldCheck, CreditCard, ChevronDown, Star, BookOpen, Users, TrendingUp, Globe, Briefcase, FileText, Lock, Zap, XCircle, Download } from 'lucide-react';
import { SocialProofPopup } from './SocialProofPopup';
const IMAGES = {
  MAIN: 'https://cdn.magicpatterns.com/uploads/pzkYURcWd9fxSgZTGQwD4j/CONJUNTO_DE_MOCKUPS_HOTELERIA_.png'
};
const LINKS = {
  MAIN_CHECKOUT: 'https://checkout.kitonline.shop/cart/47854817902830:1',
  PREMIUM_CHECKOUT: 'https://checkout.kitonline.shop/cart/47854818230510:1'
};
const AVATAR_URLS = ['https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=80&h=80&fit=crop&crop=face', 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=80&h=80&fit=crop&crop=face', 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=80&h=80&fit=crop&crop=face', 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=80&h=80&fit=crop&crop=face', 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=80&h=80&fit=crop&crop=face', 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=80&h=80&fit=crop&crop=face'];
function SocialProofAvatars() {
  return <div className="flex items-center justify-center gap-3" data-id="element-2">
      <div className="flex -space-x-2.5" data-id="element-3">
        {AVATAR_URLS.map((src, i) => <img key={i} src={src} alt="" className="w-7 h-7 md:w-9 md:h-9 rounded-full border-2 border-[#0a0f1a] object-cover" data-id="element-4" />)}
      </div>
      <div className="text-left" data-id="element-5">
        <div className="flex items-center gap-0.5" data-id="element-6">
          {[1, 2, 3, 4, 5].map(s => <Star key={s} className="w-3 h-3 md:w-3.5 md:h-3.5 text-yellow-400 fill-yellow-400" data-id="element-7" />)}
          <span className="text-white font-black text-xs md:text-sm ml-1" data-id="element-8">
            4.9
          </span>
        </div>
        <p className="text-gray-400 text-[9px] md:text-[11px] font-bold leading-tight" data-id="element-9">
          <span className="text-white" data-id="element-10">+1.800 docentes</span> ya lo usan en toda
          Argentina
        </p>
      </div>
    </div>;
}
function PricingCards({
  selectedPack,
  setSelectedPack,
  packLinks
}: {
  selectedPack: number;
  setSelectedPack: (n: number) => void;
  packLinks: string[];
}) {
  return <>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 mb-6 max-w-4xl mx-auto" data-id="element-11">
        <button onClick={() => setSelectedPack(0)} className={`relative text-left rounded-xl p-4 md:p-6 transition-all duration-300 cursor-pointer ${selectedPack === 0 ? 'bg-[#111633] border-[3px] border-[#22c55e] shadow-[0_0_25px_rgba(34,197,94,0.3)] scale-[1.02] z-10' : 'bg-[#0d1229] border-2 border-gray-700 hover:border-[#22c55e]/50'}`} data-id="element-12">
          <div className={`absolute top-4 right-4 w-5 h-5 rounded-full border-2 flex items-center justify-center ${selectedPack === 0 ? 'border-[#22c55e] bg-[#22c55e]' : 'border-gray-500'}`} data-id="element-13">
            {selectedPack === 0 && <Check className="w-3 h-3 text-white" data-id="element-14" />}
          </div>
          <p className="text-blue-400 font-black text-sm mb-1 uppercase tracking-wide" data-id="element-15">
            🚀 PACK COMPLETO
          </p>
          <h3 className="text-xl md:text-2xl font-black text-white mb-2 pr-6 leading-tight" data-id="element-16">
            KIT COMPLETO HOTELERÍA LISTA
          </h3>
          <p className="text-[#22c55e] font-bold text-xs mb-4" data-id="element-17">
            6 Tomos + 4 Bonus + Acceso inmediato
          </p>
          <div className="flex items-baseline gap-2 mb-1" data-id="element-18">
            <span className="text-3xl md:text-4xl font-black text-white" data-id="element-19">
              $19.990
            </span>
          </div>
          <span className="text-gray-500 text-sm line-through font-bold" data-id="element-20">
            $39.990
          </span>
        </button>

        <button onClick={() => setSelectedPack(1)} className={`relative text-left rounded-xl p-4 md:p-6 transition-all duration-300 cursor-pointer ${selectedPack === 1 ? 'bg-[#111633] border-[3px] border-[#22c55e] shadow-[0_0_25px_rgba(34,197,94,0.3)] scale-[1.02] z-10' : 'bg-[#0d1229] border-2 border-gray-700 hover:border-[#22c55e]/50'}`} data-id="element-21">
          <span className="absolute -top-3 left-1/2 -translate-x-1/2 bg-yellow-500 text-black text-[10px] md:text-xs font-black px-3 py-1 rounded-full uppercase tracking-widest shadow-lg whitespace-nowrap" data-id="element-22">
            ⭐ RECOMENDADO
          </span>
          <div className={`absolute top-4 right-4 w-5 h-5 rounded-full border-2 flex items-center justify-center ${selectedPack === 1 ? 'border-[#22c55e] bg-[#22c55e]' : 'border-gray-500'}`} data-id="element-23">
            {selectedPack === 1 && <Check className="w-3 h-3 text-white" data-id="element-24" />}
          </div>
          <p className="text-yellow-400 font-black text-sm mb-1 uppercase tracking-wide mt-1" data-id="element-25">
            🚀 PACK PREMIUM
          </p>
          <h3 className="text-xl md:text-2xl font-black text-white mb-1 pr-6 leading-tight" data-id="element-26">
            KIT COMPLETO + SISTEMA PRO DE SIMULACIÓN
          </h3>
          <p className="text-gray-300 font-medium mb-3 text-xs" data-id="element-27">
            Incluye TODO lo anterior + sistema avanzado:
          </p>
          <ul className="space-y-1.5 mb-4" data-id="element-28">
            <li className="flex items-start gap-1.5 text-gray-300 font-bold text-xs" data-id="element-29">
              <Check className="w-4 h-4 text-[#22c55e] flex-shrink-0" data-id="element-30" />{' '}
              Simulaciones profesionales paso a paso
            </li>
            <li className="flex items-start gap-1.5 text-gray-300 font-bold text-xs" data-id="element-31">
              <Check className="w-4 h-4 text-[#22c55e] flex-shrink-0" data-id="element-32" />{' '}
              Evaluación de desempeño real
            </li>
            <li className="flex items-start gap-1.5 text-gray-300 font-bold text-xs" data-id="element-33">
              <Check className="w-4 h-4 text-[#22c55e] flex-shrink-0" data-id="element-34" />{' '}
              Instrumentos avanzados
            </li>
            <li className="flex items-start gap-1.5 text-gray-300 font-bold text-xs" data-id="element-35">
              <Check className="w-4 h-4 text-[#22c55e] flex-shrink-0" data-id="element-36" /> Clases
              prácticas de alto nivel
            </li>
          </ul>
          <div className="flex items-baseline gap-2 mb-1" data-id="element-37">
            <span className="text-3xl md:text-4xl font-black text-white" data-id="element-38">
              $27.990
            </span>
          </div>
          <span className="text-gray-500 text-sm line-through font-bold" data-id="element-39">
            $49.990
          </span>
        </button>
      </div>

      <div className="text-center" data-id="element-40">
        <a href={packLinks[selectedPack]} className="inline-flex items-center justify-center w-full md:w-auto bg-[#22c55e] hover:bg-[#16a34a] text-white font-black text-lg md:text-2xl py-4 px-8 md:px-14 rounded-xl shadow-[0_0_40px_rgba(34,197,94,0.5)] transform hover:scale-105 transition-all duration-200 uppercase tracking-wide mb-3" data-id="element-41">
          👉 QUIERO MI KIT COMPLETO
        </a>
        <div className="flex items-center justify-center gap-4 text-gray-400 font-bold text-[10px] md:text-xs" data-id="element-42">
          <span className="flex items-center gap-1" data-id="element-43">
            <CreditCard className="w-4 h-4 text-[#22c55e]" data-id="element-44" /> Pago seguro
          </span>
          <span className="flex items-center gap-1" data-id="element-45">
            <Download className="w-4 h-4 text-[#22c55e]" data-id="element-46" /> Acceso inmediato
          </span>
        </div>
      </div>
    </>;
}
export function SalesPage() {
  const [openCuadernillo, setOpenCuadernillo] = useState<number | null>(null);
  const [selectedPack, setSelectedPack] = useState(1);
  const packLinks = [LINKS.MAIN_CHECKOUT, LINKS.PREMIUM_CHECKOUT];
  const [urgencyTime, setUrgencyTime] = useState({
    hours: 2,
    minutes: 13,
    seconds: 30
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setUrgencyTime(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        seconds--;
        if (seconds < 0) {
          seconds = 59;
          minutes--;
        }
        if (minutes < 0) {
          minutes = 59;
          hours--;
        }
        if (hours < 0) {
          hours = 0;
          minutes = 0;
          seconds = 0;
        }
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className="font-sans bg-[#0a0f1a] text-white min-h-screen flex flex-col selection:bg-[#22c55e] selection:text-white" data-id="element-47">
      <SocialProofPopup data-id="element-48" />

      {/* HERO */}
      <section className="pt-3 pb-0 px-3 text-center" data-id="element-49">
        <div className="max-w-4xl mx-auto flex flex-col items-center" data-id="element-50">
          <span className="text-[8px] md:text-[11px] text-gray-400 font-bold uppercase tracking-widest" data-id="element-51">
            ⭐ EL RECURSO #1 PARA DOCENTES DE HOTELERÍA Y TURISMO ⭐
          </span>

          <h1 className="text-lg md:text-3xl lg:text-4xl font-black text-white leading-tight tracking-tight mt-1" data-id="element-52">
            Todavía estás a tiempo de ordenar tu año de hotelería…{' '}
            <span className="text-[#22c55e]" data-id="element-53">sin seguir improvisando</span>
          </h1>

          <div onClick={scrollToPricing} className="cursor-pointer hover:scale-[1.02] transition-transform duration-300 w-full max-w-md mx-auto mt-1" data-id="element-54">
            <img src={IMAGES.MAIN} alt="Kit Completo Hotelería Lista Mockup" className="w-full drop-shadow-[0_0_30px_rgba(34,197,94,0.3)]" data-id="element-55" />
          </div>

          <p className="text-[11px] md:text-sm text-gray-300 max-w-2xl mx-auto font-medium leading-snug mt-1" data-id="element-56">
            Diseñado por docentes, para que dejes de perder horas armando clases
            y tengas todo listo para aplicar desde hoy mismo, incluso si ya
            empezaste el año.
          </p>

          <div className="flex flex-wrap justify-center gap-1.5 mt-2" data-id="element-57">
            <span className="flex items-center gap-1 border border-[#22c55e]/30 bg-[#22c55e]/10 text-white text-[9px] md:text-[11px] font-bold px-2 py-0.5 rounded-full" data-id="element-58">
              <FileText className="w-2.5 h-2.5 text-[#22c55e]" data-id="element-59" /> 100% PDF
            </span>
            <span className="flex items-center gap-1 border border-[#22c55e]/30 bg-[#22c55e]/10 text-white text-[9px] md:text-[11px] font-bold px-2 py-0.5 rounded-full" data-id="element-60">
              <Zap className="w-2.5 h-2.5 text-[#22c55e]" data-id="element-61" /> Acceso inmediato
            </span>
            <span className="flex items-center gap-1 border border-[#22c55e]/30 bg-[#22c55e]/10 text-white text-[9px] md:text-[11px] font-bold px-2 py-0.5 rounded-full" data-id="element-62">
              🇦🇷 Argentina
            </span>
          </div>

          <button onClick={scrollToPricing} className="w-full md:w-auto inline-flex items-center justify-center bg-[#22c55e] hover:bg-[#16a34a] text-white font-black text-sm md:text-lg py-3 px-6 md:px-10 rounded-xl shadow-[0_0_30px_rgba(34,197,94,0.4)] transform hover:scale-105 transition-all duration-200 mt-2 uppercase tracking-wide" data-id="element-63">
            👉 QUIERO MI KIT COMPLETO
          </button>

          <div className="flex flex-wrap justify-center gap-3 text-[9px] md:text-[11px] text-gray-400 font-bold mt-2" data-id="element-64">
            <span className="flex items-center gap-1" data-id="element-65">
              <ShieldCheck className="w-3 h-3 text-[#22c55e]" data-id="element-66" /> Garantía 7 días
            </span>
            <span className="flex items-center gap-1" data-id="element-67">
              <Lock className="w-3 h-3 text-[#22c55e]" data-id="element-68" /> Pago seguro
            </span>
            <span className="flex items-center gap-1" data-id="element-69">
              <CreditCard className="w-3 h-3 text-[#22c55e]" data-id="element-70" /> Mercado Pago
            </span>
          </div>
        </div>
      </section>

      {/* PAIN POINTS */}
      <section className="py-4 md:py-6 px-3" data-id="element-71">
        <div className="max-w-2xl mx-auto bg-[#111633] border-2 border-[#22c55e] rounded-xl p-4 md:p-6 shadow-[0_0_20px_rgba(34,197,94,0.15)]" data-id="element-72">
          <h2 className="text-lg md:text-2xl font-black text-center text-white mb-3" data-id="element-73">
            <span className="text-red-500" data-id="element-74">❌</span> ¿Te pasa esto?
          </h2>
          <div className="space-y-2 text-xs md:text-sm text-gray-300 font-medium" data-id="element-75">
            <p className="flex items-start gap-2" data-id="element-76">
              <XCircle className="w-4 h-4 text-red-500 flex-shrink-0 mt-0.5" data-id="element-77" />{' '}
              Empezaste el año… pero seguís armando clases sobre la marcha
            </p>
            <p className="flex items-start gap-2" data-id="element-78">
              <XCircle className="w-4 h-4 text-red-500 flex-shrink-0 mt-0.5" data-id="element-79" />{' '}
              Buscás material de hotelería… y no hay nada práctico para
              secundaria
            </p>
            <p className="flex items-start gap-2" data-id="element-80">
              <XCircle className="w-4 h-4 text-red-500 flex-shrink-0 mt-0.5" data-id="element-81" />{' '}
              Terminás dando teoría cuando debería ser una materia práctica
            </p>
            <p className="flex items-start gap-2" data-id="element-82">
              <XCircle className="w-4 h-4 text-red-500 flex-shrink-0 mt-0.5" data-id="element-83" />{' '}
              Tenés que inventar actividades porque no existe material completo
            </p>
            <p className="flex items-start gap-2" data-id="element-84">
              <XCircle className="w-4 h-4 text-red-500 flex-shrink-0 mt-0.5" data-id="element-85" />{' '}
              Las planificaciones y evaluaciones te siguen consumiendo horas
            </p>
            <p className="flex items-start gap-2" data-id="element-86">
              <XCircle className="w-4 h-4 text-red-500 flex-shrink-0 mt-0.5" data-id="element-87" />{' '}
              Querés hacer simulaciones reales… pero no sabés cómo aplicarlas
            </p>
          </div>
        </div>
      </section>

      {/* SOLUTION */}
      <section className="py-4 md:py-6 px-3" data-id="element-88">
        <div className="max-w-2xl mx-auto bg-[#111633] border-2 border-[#22c55e] rounded-xl p-4 md:p-6 shadow-[0_0_20px_rgba(34,197,94,0.15)]" data-id="element-89">
          <h2 className="text-lg md:text-2xl font-black text-center text-white mb-3" data-id="element-90">
            <span className="text-[#22c55e]" data-id="element-91">✅</span> CON ESTE KIT VAS A PODER:
          </h2>
          <div className="space-y-2 text-xs md:text-sm text-white font-bold" data-id="element-92">
            <p className="flex items-start gap-2" data-id="element-93">
              <Check className="w-4 h-4 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-94" />{' '}
              Ordenar TODO tu año aunque ya hayas empezado
            </p>
            <p className="flex items-start gap-2" data-id="element-95">
              <Check className="w-4 h-4 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-96" />{' '}
              Dar clases de hotelería prácticas, claras y listas para usar
            </p>
            <p className="flex items-start gap-2" data-id="element-97">
              <Check className="w-4 h-4 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-98" />{' '}
              Tener actividades, simulaciones y evaluaciones sin preparar nada
            </p>
            <p className="flex items-start gap-2" data-id="element-99">
              <Check className="w-4 h-4 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-100" />{' '}
              Conectar con tus alumnos con situaciones reales de hotel
            </p>
            <p className="flex items-start gap-2" data-id="element-101">
              <Check className="w-4 h-4 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-102" />{' '}
              Ahorrar horas de trabajo todas las semanas
            </p>
          </div>
        </div>
      </section>

      {/* PERSUASIVE CTA */}
      <section className="py-2 px-3 text-center" data-id="element-103">
        <button onClick={scrollToPricing} className="w-full md:w-auto inline-flex items-center justify-center bg-[#22c55e] hover:bg-[#16a34a] text-white font-black text-sm md:text-lg py-3 px-6 md:px-10 rounded-xl shadow-[0_0_30px_rgba(34,197,94,0.4)] transform hover:scale-105 transition-all duration-200 uppercase tracking-wide" data-id="element-104">
          🚀 SÍ, QUIERO DEJAR DE IMPROVISAR Y TENER TODO LISTO
        </button>
      </section>

      {/* CONTENTS */}
      <section className="py-5 md:py-8 px-3" data-id="element-105">
        <div className="max-w-3xl mx-auto" data-id="element-106">
          <div className="text-center mb-4" data-id="element-107">
            <h2 className="text-xl md:text-3xl font-black text-white mb-1" data-id="element-108">
              📦 ¿QUÉ INCLUYE EL KIT?
            </h2>
            <p className="text-sm md:text-base text-[#22c55e] font-bold" data-id="element-109">
              📚 +360 páginas · 6 tomos · Listo para usar todo el año
            </p>
          </div>

          <div className="space-y-2" data-id="element-110">
            {[{
            idx: 0,
            icon: <BookOpen className="w-6 h-6 text-blue-400 flex-shrink-0" data-id="element-111" />,
            emoji: '📘',
            title: 'TOMO 1 — Introducción a la Hotelería y el Turismo',
            topics: ['Qué es la hotelería', 'Tipos de alojamiento', 'Turismo en Argentina', 'Perfil del cliente'],
            includes: ['actividades prácticas', 'análisis de casos reales', 'ejercicios guiados', 'contenido aplicado']
          }, {
            idx: 1,
            icon: <Users className="w-6 h-6 text-green-400 flex-shrink-0" data-id="element-112" />,
            emoji: '📗',
            title: 'TOMO 2 — Organización Interna del Hotel',
            topics: ['Estructura hotelera', 'Áreas y funciones', 'Roles laborales', 'Trabajo en equipo'],
            includes: ['creación de organigramas', 'actividades prácticas', 'análisis de situaciones', 'ejercicios aplicados']
          }, {
            idx: 2,
            icon: <Globe className="w-6 h-6 text-orange-400 flex-shrink-0" data-id="element-113" />,
            emoji: '📙',
            title: 'TOMO 3 — Atención al Cliente y Calidad de Servicio',
            topics: ['Atención al cliente', 'Tipos de clientes', 'Comunicación', 'Manejo de quejas'],
            includes: ['role play en clase', 'simulaciones', 'actividades reales', 'ejercicios prácticos']
          }, {
            idx: 3,
            icon: <Briefcase className="w-6 h-6 text-red-400 flex-shrink-0" data-id="element-114" />,
            emoji: '📕',
            title: 'TOMO 4 — Operaciones Hoteleras',
            topics: ['Reservas', 'Check-in', 'Check-out', 'Registro de huéspedes'],
            includes: ['simulaciones completas', 'formularios reales', 'actividades prácticas', 'resolución de errores']
          }, {
            idx: 4,
            icon: <ShieldCheck className="w-6 h-6 text-yellow-400 flex-shrink-0" data-id="element-115" />,
            emoji: '📒',
            title: 'TOMO 5 — Higiene, Seguridad y Mantenimiento',
            topics: ['Limpieza y protocolos', 'Seguridad hotelera', 'Prevención de riesgos', 'Mantenimiento'],
            includes: ['checklist', 'actividades prácticas', 'análisis de riesgos', 'ejercicios aplicados']
          }, {
            idx: 5,
            icon: <TrendingUp className="w-6 h-6 text-purple-400 flex-shrink-0" data-id="element-116" />,
            emoji: '📓',
            title: 'TOMO 6 — Hotelería en Argentina y Salida Laboral',
            topics: ['Hotelería en el país', 'Destinos turísticos', 'Trabajo en hotelería', 'Emprendimientos'],
            includes: ['investigación guiada', 'proyecto final', 'actividades aplicadas', 'evaluación completa']
          }].map(tomo => <div key={tomo.idx} className="bg-[#111633] rounded-lg border-2 border-[#22c55e] overflow-hidden shadow-[0_0_10px_rgba(34,197,94,0.1)]" data-id="element-117">
                <button onClick={() => setOpenCuadernillo(openCuadernillo === tomo.idx ? null : tomo.idx)} className="w-full flex items-center gap-2 p-3 md:p-4 text-left cursor-pointer hover:bg-[#1a2247] transition-colors" data-id="element-118">
                  {tomo.icon}
                  <h3 className="text-sm md:text-base font-black text-white flex-1" data-id="element-119">
                    {tomo.emoji} {tomo.title}
                  </h3>
                  <ChevronDown className={`w-5 h-5 text-[#22c55e] flex-shrink-0 transition-transform duration-300 ${openCuadernillo === tomo.idx ? 'rotate-180' : ''}`} data-id="element-120" />
                </button>
                <AnimatePresence data-id="element-121">
                  {openCuadernillo === tomo.idx && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} className="overflow-hidden" data-id="element-122">
                      <div className="px-3 md:px-6 pb-4 border-t border-[#22c55e]/30 pt-3" data-id="element-123">
                        <div className="grid grid-cols-2 gap-3" data-id="element-124">
                          <ul className="space-y-1.5 text-gray-300 text-xs font-medium" data-id="element-125">
                            {tomo.topics.map((t, i) => <li key={i} className="flex items-center gap-1.5" data-id="element-126">
                                <Check className="w-3 h-3 text-[#22c55e]" data-id="element-127" /> {t}
                              </li>)}
                          </ul>
                          <div className="bg-[#0a0f1a] p-3 rounded-lg border border-[#22c55e]/20" data-id="element-128">
                            <p className="text-[#22c55e] font-bold text-xs mb-1" data-id="element-129">
                              Incluye:
                            </p>
                            <ul className="space-y-0.5 text-gray-400 text-[11px]" data-id="element-130">
                              {tomo.includes.map((inc, i) => <li key={i} data-id="element-131">• {inc}</li>)}
                            </ul>
                          </div>
                        </div>
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>)}
          </div>
        </div>
      </section>

      {/* BONUSES */}
      <section className="py-5 md:py-8 px-3" data-id="element-132">
        <div className="max-w-3xl mx-auto" data-id="element-133">
          <h2 className="text-xl md:text-3xl font-black text-center text-white mb-4" data-id="element-134">
            🎁 BONUS EXCLUSIVOS INCLUIDOS
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-4" data-id="element-135">
            {[{
            num: 1,
            title: 'Planificación Anual Completa',
            val: '$8.500',
            items: ['Organización del año', 'Secuencia de contenidos', 'Objetivos claros', 'Listo para presentar']
          }, {
            num: 2,
            title: 'Simulaciones Hoteleras para el Aula',
            val: '$8.500',
            items: ['Check-in real', 'Cliente difícil', 'Resolución de problemas', 'Actividades prácticas']
          }, {
            num: 3,
            title: 'Sistema PRO de Evaluación',
            val: '$8.000',
            items: ['Rúbricas por capacidades', 'Evaluaciones listas', 'Instrumentos completos', 'Evaluación práctica']
          }, {
            num: 4,
            title: '100 Actividades de Hotelería',
            val: '$9.000',
            items: ['Actividades listas', 'Dinámicas grupales', 'Casos reales', 'Aplicación directa']
          }].map(b => <div key={b.num} className="bg-[#111633] border-2 border-[#22c55e] rounded-lg p-4 shadow-[0_0_15px_rgba(34,197,94,0.1)]" data-id="element-136">
                <span className="inline-block bg-red-600 text-white text-[10px] font-black px-2 py-0.5 rounded-full uppercase tracking-wider mb-2" data-id="element-137">
                  BONUS {b.num}
                </span>
                <h3 className="text-sm md:text-base font-black text-white mb-1" data-id="element-138">
                  {b.title}
                </h3>
                <p className="text-gray-400 text-[11px] font-bold mb-2" data-id="element-139">
                  (Valor {b.val} —{' '}
                  <span className="text-[#22c55e]" data-id="element-140">HOY GRATIS</span>)
                </p>
                <ul className="space-y-1 text-gray-300 text-xs font-medium" data-id="element-141">
                  {b.items.map((item, i) => <li key={i} className="flex items-center gap-1.5" data-id="element-142">
                      <Check className="w-3.5 h-3.5 text-[#22c55e]" data-id="element-143" /> {item}
                    </li>)}
                </ul>
              </div>)}
          </div>
          <div className="max-w-sm mx-auto bg-[#111633] border-2 border-[#22c55e] rounded-xl p-4 text-center shadow-[0_0_20px_rgba(34,197,94,0.2)]" data-id="element-144">
            <p className="text-gray-400 text-sm font-bold mb-1" data-id="element-145">
              💰 VALOR TOTAL:{' '}
              <span className="line-through text-red-500" data-id="element-146">$34.000</span>
            </p>
            <p className="text-[#22c55e] text-3xl font-black mb-1" data-id="element-147">HOY $0</p>
            <p className="text-white font-bold text-xs" data-id="element-148">
              Incluidos GRATIS con tu compra
            </p>
          </div>
        </div>
      </section>

      {/* URGENCY */}
      <section className="py-5 px-3" data-id="element-149">
        <div className="max-w-2xl mx-auto text-center" data-id="element-150">
          <h2 className="text-lg md:text-2xl font-black text-yellow-400 mb-4 uppercase tracking-wide" data-id="element-151">
            El precio de lanzamiento termina en
          </h2>
          <div className="flex items-center justify-center gap-2 md:gap-4 mb-4" data-id="element-152">
            {[{
            val: String(urgencyTime.hours).padStart(2, '0'),
            label: 'Horas'
          }, {
            val: String(urgencyTime.minutes).padStart(2, '0'),
            label: 'Minutos'
          }, {
            val: String(urgencyTime.seconds).padStart(2, '0'),
            label: 'Segundos'
          }].map((t, i) => <Fragment key={i} data-id="element-153">
                {i > 0 && <span className="text-red-500 text-2xl md:text-4xl font-black -mt-4" data-id="element-154">
                    :
                  </span>}
                <div className="flex flex-col items-center" data-id="element-155">
                  <div className="bg-red-600 border-2 border-red-400 rounded-lg w-12 h-12 md:w-20 md:h-20 flex items-center justify-center shadow-[0_0_15px_rgba(220,38,38,0.5)]" data-id="element-156">
                    <span className="text-white text-2xl md:text-5xl font-black" data-id="element-157">
                      {t.val}
                    </span>
                  </div>
                  <span className="text-gray-400 text-[9px] md:text-xs font-bold uppercase tracking-wider mt-1" data-id="element-158">
                    {t.label}
                  </span>
                </div>
              </Fragment>)}
          </div>
          <div className="max-w-sm mx-auto" data-id="element-159">
            <div className="relative w-full h-4 bg-gray-800 rounded-full overflow-hidden border border-gray-700" data-id="element-160">
              <div className="h-full rounded-full bg-gradient-to-r from-orange-500 to-red-600" style={{
              width: '85%'
            }} data-id="element-161" />
            </div>
            <p className="text-[#22c55e] text-xs font-black mt-2 uppercase tracking-wider" data-id="element-162">
              🔥 85% de cupos ocupados
            </p>
          </div>
        </div>
      </section>

      {/* PRICING */}
      <section id="pricing" className="py-6 md:py-10 px-3" data-id="element-163">
        <div className="max-w-4xl mx-auto" data-id="element-164">
          <h2 className="text-xl md:text-3xl font-black text-white text-center mb-6" data-id="element-165">
            🔥 HOY: ACCESO COMPLETO CON DESCUENTO ESPECIAL
          </h2>
          <PricingCards selectedPack={selectedPack} setSelectedPack={setSelectedPack} packLinks={packLinks} data-id="element-166" />
          <div className="mt-4" data-id="element-167">
            <SocialProofAvatars data-id="element-168" />
          </div>
        </div>
      </section>

      {/* HOW IT WORKS */}
      <section className="py-5 px-3" data-id="element-169">
        <div className="max-w-3xl mx-auto bg-[#111633] border-2 border-[#22c55e] rounded-xl p-4 md:p-6 shadow-[0_0_20px_rgba(34,197,94,0.15)]" data-id="element-170">
          <div className="grid grid-cols-3 gap-3 text-center" data-id="element-171">
            {[{
            n: '1',
            t: 'Comprás'
          }, {
            n: '2',
            t: 'Pagás'
          }, {
            n: '3',
            t: 'Descargás'
          }].map(s => <div key={s.n} data-id="element-172">
                <div className="w-10 h-10 md:w-14 md:h-14 bg-[#22c55e]/20 border-2 border-[#22c55e] rounded-full flex items-center justify-center text-xl md:text-2xl font-black text-[#22c55e] mx-auto mb-2 shadow-[0_0_10px_rgba(34,197,94,0.3)]" data-id="element-173">
                  {s.n}
                </div>
                <h3 className="text-sm md:text-base font-black text-white uppercase" data-id="element-174">
                  {s.t}
                </h3>
              </div>)}
          </div>
        </div>
      </section>

      {/* GUARANTEE */}
      <section className="py-5 px-3" data-id="element-175">
        <div className="max-w-2xl mx-auto text-center bg-[#111633] border-2 border-[#22c55e] rounded-xl p-5 shadow-[0_0_20px_rgba(34,197,94,0.15)]" data-id="element-176">
          <ShieldCheck className="w-14 h-14 text-[#22c55e] mx-auto mb-3 drop-shadow-[0_0_10px_rgba(34,197,94,0.5)]" data-id="element-177" />
          <h2 className="text-xl md:text-2xl font-black text-white mb-2 uppercase" data-id="element-178">
            Garantía de 7 Días
          </h2>
          <p className="text-sm md:text-base text-gray-300 font-medium" data-id="element-179">
            Probalo 7 días. Si no cumple tus expectativas, te devolvemos el
            100%. Sin preguntas.
          </p>
        </div>
      </section>

      {/* TESTIMONIALS */}
      <section className="py-6 px-3" data-id="element-180">
        <div className="max-w-4xl mx-auto" data-id="element-181">
          <h2 className="text-xl md:text-3xl font-black text-center text-white mb-5 uppercase" data-id="element-182">
            Testimonios de docentes
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3" data-id="element-183">
            {[{
            text: 'Las simulaciones prácticas son increíbles. Mis alumnos por fin entienden cómo funciona la recepción de un hotel real. ¡Me salvó el año!',
            author: 'Mariana G., 32 años',
            loc: 'Córdoba'
          }, {
            text: 'Antes perdía todo el fin de semana armando clases y buscando material que no existía. Ahora tengo todo organizado y listo para imprimir.',
            author: 'Roberto M., 45 años',
            loc: 'Buenos Aires'
          }, {
            text: 'Los casos reales de atención al cliente engancharon a todos mis alumnos. Es la primera vez que veo un material tan adaptado a la secundaria.',
            author: 'Silvia T., 38 años',
            loc: 'Mendoza'
          }, {
            text: 'El módulo de check-in y check-out fue un éxito total. Hicimos role-play en clase y los chicos aprendieron muchísimo más que leyendo teoría.',
            author: 'Federico L., 41 años',
            loc: 'Salta'
          }, {
            text: 'Por fin un kit que tiene estructura para todo el año. Las rúbricas de evaluación me ahorraron horas de trabajo administrativo. 100% recomendado.',
            author: 'Carolina V., 50 años',
            loc: 'Rosario'
          }].map((t, i) => <div key={i} className="bg-[#111633] p-4 rounded-xl border-2 border-[#22c55e] shadow-[0_0_15px_rgba(34,197,94,0.1)]" data-id="element-184">
                <div className="flex gap-0.5 mb-2" data-id="element-185">
                  {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-3.5 h-3.5 text-yellow-400 fill-yellow-400" data-id="element-186" />)}
                </div>
                <p className="text-gray-300 mb-3 font-medium text-xs italic leading-relaxed" data-id="element-187">
                  "{t.text}"
                </p>
                <div className="font-black text-white text-sm" data-id="element-188">
                  {t.author}{' '}
                  <span className="text-[#22c55e] font-bold block text-[11px] mt-0.5" data-id="element-189">
                    {t.loc}
                  </span>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-6 px-3" data-id="element-190">
        <div className="max-w-2xl mx-auto" data-id="element-191">
          <h2 className="text-xl md:text-3xl font-black text-center text-white mb-5 uppercase" data-id="element-192">
            Preguntas Frecuentes
          </h2>
          <div className="space-y-2" data-id="element-193">
            {[{
            q: '¿En qué formato recibo el material?',
            a: 'Recibís todo en formato PDF, listo para descargar e imprimir o usar en formato digital.'
          }, {
            q: '¿Puedo imprimir el material?',
            a: 'Sí, podés imprimir todo el material las veces que necesites.'
          }, {
            q: '¿Para qué año de secundaria sirve?',
            a: 'El kit está diseñado para todos los años de secundaria donde se dicte Hotelería.'
          }, {
            q: '¿Incluye actividades prácticas y simulaciones?',
            a: 'Sí, incluye simulaciones de check-in, atención al cliente, resolución de quejas y role-play.'
          }, {
            q: '¿Necesito materiales especiales para usarlo?',
            a: 'No, solo necesitás una computadora o celular para descargar el material.'
          }, {
            q: '¿Cuánto tarda en llegar?',
            a: 'El acceso es inmediato. Apenas completás el pago, recibís el link de descarga en tu correo.'
          }, {
            q: '¿Sirve si ya empecé el año?',
            a: 'Sí, podés ordenar tu año desde donde estés y aplicar las actividades inmediatamente.'
          }, {
            q: '¿Tiene garantía?',
            a: 'Sí, 7 días de garantía total. Si no te sirve, te devolvemos el 100%.'
          }, {
            q: '¿El acceso es permanente?',
            a: 'Sí, el acceso es de por vida sin vencimiento.'
          }, {
            q: '¿Funciona para todas las provincias argentinas?',
            a: 'Sí, el contenido es aplicable en todo el territorio nacional.'
          }].map((faq, i) => <details key={i} className="group bg-[#111633] rounded-lg border-2 border-[#22c55e] overflow-hidden shadow-[0_0_10px_rgba(34,197,94,0.1)]" data-id="element-194">
                <summary className="flex items-center justify-between cursor-pointer p-3 md:p-4 font-black text-white list-none text-sm md:text-base" data-id="element-195">
                  {faq.q}
                  <ChevronDown className="w-5 h-5 text-[#22c55e] group-open:rotate-180 transition-transform flex-shrink-0 ml-2" data-id="element-196" />
                </summary>
                <div className="px-3 pb-3 md:px-4 md:pb-4 text-gray-300 text-xs md:text-sm font-medium leading-relaxed border-t border-[#22c55e]/30 pt-3" data-id="element-197">
                  {faq.a}
                </div>
              </details>)}
          </div>
        </div>
      </section>

      {/* BOTTOM PRICING */}
      <section className="py-6 md:py-10 px-3" data-id="element-198">
        <div className="max-w-4xl mx-auto" data-id="element-199">
          <h2 className="text-xl md:text-3xl font-black text-white text-center mb-6" data-id="element-200">
            🔥 ÚLTIMA OPORTUNIDAD — ELEGÍ TU PACK
          </h2>
          <PricingCards selectedPack={selectedPack} setSelectedPack={setSelectedPack} packLinks={packLinks} data-id="element-201" />
          <div className="mt-4" data-id="element-202">
            <SocialProofAvatars data-id="element-203" />
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="bg-[#05080f] text-gray-500 py-6 px-3 text-center font-bold text-xs border-t border-[#22c55e]/20" data-id="element-204">
        <p className="mb-2" data-id="element-205">© 2026 Kit Completo Hotelería Lista™</p>
        <div className="flex justify-center gap-4" data-id="element-206">
          <span className="hover:text-white cursor-pointer transition-colors" data-id="element-207">
            Términos
          </span>
          <span className="hover:text-white cursor-pointer transition-colors" data-id="element-208">
            Privacidad
          </span>
          <span className="hover:text-white cursor-pointer transition-colors" data-id="element-209">
            Soporte
          </span>
        </div>
      </footer>
    </div>;
}